
import React from 'react'
import { useState } from 'react';
import ListingsSubCategoriesTable from './table';

function ListingSubCategories() {
  const [filters, setFilters] = useState({
    offset: 1,
   limit: 10,
   id : null,

 
 });

  
  return (
    <div>
      <ListingsSubCategoriesTable filters={filters} setFilters={setFilters} /></div>
  )
}

export default ListingSubCategories
